export { default as $TextEditor } from './TextEditor';